export default __webpack_public_path__ + "static/media/padlock.1345e6cd.svg";